import { useTheme } from "@/theme/ThemeProvider";
import { HIT_TARGET_MIN } from "@/ui/components/listRowA11y";
import { CheckIcon } from "phosphor-react-native";
import { Platform, Pressable, Text, View } from "react-native";

const ACK_LABEL = "Datenschutzinformation wurde bereitgestellt und dokumentiert";

/** Nur die Kenntnisnahme. Kennt die Art der Bereitstellung nicht. */
export function FinderPrivacyAck({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  const { theme } = useTheme();

  return (
    <Pressable
      onPress={() => onChange(!checked)}
      accessibilityRole="checkbox"
      accessibilityState={{ checked }}
      {...(Platform.OS === "web" ? { "aria-checked": checked } : {})}
      accessibilityLabel={ACK_LABEL}
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: theme.space.sm,
        minHeight: HIT_TARGET_MIN,
        minWidth: HIT_TARGET_MIN,
      }}
    >
      <View
        style={{
          width: HIT_TARGET_MIN,
          height: HIT_TARGET_MIN,
          borderRadius: theme.radius.sm,
          borderWidth: 2,
          borderColor: checked ? theme.color.buttonBg : theme.color.inputBorder,
          backgroundColor: checked ? theme.color.buttonBg : theme.color.surface,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {checked ? (
          <CheckIcon size={22} color={theme.color.buttonText} weight="bold" />
        ) : null}
      </View>
      <Text style={{ color: theme.color.text, flex: 1, fontSize: theme.fontSize.body }}>
        {ACK_LABEL}
      </Text>
    </Pressable>
  );
}
